import React from 'react';
import { ArrowDownIcon, BookOpenIcon, LayoutGridIcon, RulerIcon } from 'lucide-react';
import { PREVIEW_ANCHOR } from '../../data/collection';
import { secondaryLinkClass } from '../../utils/buttonStyles';
const BENEFITS = [{
  icon: LayoutGridIcon,
  title: 'Variedad para elegir',
  text: 'Vestidos, ranitas, enteritos y conjuntos para tus proyectos o tu catálogo.'
}, {
  icon: RulerIcon,
  title: 'Moldes A4 y 10 talles',
  text: 'Elegí el talle según la estatura y las medidas e imprimí el molde correspondiente.'
}, {
  icon: BookOpenIcon,
  title: 'Manuales para acompañarte',
  text: 'Consultá las piezas, la preparación, el armado y las terminaciones de cada modelo.'
}];

/** Three short benefits, no price. */
export function BenefitsSection() {
  return <section aria-labelledby="beneficios-title" className="w-full bg-ivory" data-id="element-157" data-mp="b7e8tnonwsf1">
      <div className="mx-auto max-w-6xl px-5 py-12 sm:px-8 lg:py-16" data-id="element-158" data-mp="68b1txp4gc4f">
        <h2 id="beneficios-title" className="sr-only" data-id="element-159" data-mp="6a49ngbh12e0">
          Qué incluye la colección
        </h2>
        <ul className="grid grid-cols-1 gap-x-10 divide-y divide-dashed divide-coral/35 md:grid-cols-3 md:divide-y-0 [&>*]:min-w-0" data-id="element-160" data-mp="1gvud4vuja0ow">
          {BENEFITS.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex gap-4 py-5 first:pt-0 last:pb-0 md:flex-col md:gap-3 md:py-0" data-id="element-161" data-mp="171vh8el1zd5e">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blush text-coral-ink" data-id="element-162" data-mp="1c0ovwac2ta75">
                <Icon className="h-5 w-5" aria-hidden data-id="element-163" data-mp="120fwknmsf8nj" />
              </span>
              <div className="min-w-0" data-id="element-164" data-mp="122ivjx5x4c4e">
                <h3 className="font-serif text-[1.3rem] font-semibold leading-tight text-graphite sm:text-[1.45rem]" data-id="element-165" data-mp="oa2oml9wbty7">{title}</h3>
                <p className="mt-1.5 text-[1rem] leading-relaxed text-graphite-soft" data-id="element-166" data-mp="t8w0k99jbcw9">{text}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-8 flex justify-center md:mt-10" data-id="element-167" data-mp="jaq1dzf44kv3">
          <a href={PREVIEW_ANCHOR} className={secondaryLinkClass} data-id="element-168" data-mp="jcavjnxim1sf">
            Mirá cómo viene por dentro
            <ArrowDownIcon className="h-4 w-4 shrink-0" aria-hidden data-id="element-169" data-mp="7eghxabrzpk" />
          </a>
        </div>
      </div>
    </section>;
}